var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.1369 5.96267C25.4649 6.29084 25.6492 6.73588 25.6492 7.19992C25.6492 7.66395 25.4649 8.10899 25.1369 8.43717L12.02 21.554C11.8467 21.7274 11.6409 21.8649 11.4144 21.9588C11.1879 22.0526 10.9451 22.1009 10.7 22.1009C10.4548 22.1009 10.212 22.0526 9.98551 21.9588C9.75901 21.8649 9.55321 21.7274 9.37987 21.554L2.86287 15.0382C2.69572 14.8767 2.56241 14.6836 2.47069 14.4701C2.37897 14.2566 2.3307 14.027 2.32868 13.7946C2.32666 13.5623 2.37094 13.3318 2.45893 13.1167C2.54692 12.9017 2.67686 12.7063 2.84118 12.542C3.00549 12.3777 3.20088 12.2477 3.41595 12.1597C3.63102 12.0717 3.86146 12.0275 4.09382 12.0295C4.32618 12.0315 4.55582 12.0798 4.76933 12.1715C4.98283 12.2632 5.17594 12.3965 5.33737 12.5637L10.6994 17.9257L22.6612 5.96267C22.8237 5.80005 23.0167 5.67104 23.2291 5.58303C23.4415 5.49501 23.6691 5.44971 23.899 5.44971C24.1289 5.44971 24.3566 5.49501 24.569 5.58303C24.7814 5.67104 24.9743 5.80005 25.1369 5.96267Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.4d217381fe8a18103dbdff5a95ad2f39.svg";
export { ForwardRef as ReactComponent };